/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {FC, useEffect, useMemo, useCallback} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {getLaundryBilling} from '../../../../services'
import {getFormatDate} from '../../../../../../util/functions'
import {
  LaundryBillingModel,
  LaundryFilterReportModel,
} from '../../../../features/laundryBilling/model/laundryBilling.model'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'

interface PropsTable {
  search?: any
}

interface FormattedDate {
  fecha: string
  tiempo: string
}
const TableLaundryHystory: FC<PropsTable> = ({search}) => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const {isAllowed} = useLavanderia()

  const getLaundryList = useCallback(
    async (props: LaundryFilterReportModel = {}) => {
      setLoading(true)
      try {
        const response = await getLaundryBilling({...props}, pagination.currentPage)
        const dataInfo = response.data?.data || []
        setData(dataInfo)
        setPagination({
          ...pagination,
          totalResults: response.data.total,
        })
      } catch (error) {
        console.log(error)
      }
      setLoading(false)
    },
    [setLoading, setData, pagination.currentPage],
  )

  const columns: Column<LaundryBillingModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Compañía' />,
        accessor: 'compania',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Cliente' />,
        accessor: 'cliente',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Site' />,
        accessor: 'site',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Punto de Lavandería' />,
        accessor: 'puntoLavado',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fecha de lavado' />,
        accessor: 'fechaLavado',
        Cell: ({...props}) => {
          let dateCreation = props.data[props.row.index].fechaLavado
            ? getFormatDate(props.data[props.row.index].fechaLavado)
            : ''
          return (
            <span>
              {dateCreation
                ? `${(dateCreation as FormattedDate).fecha} ${
                    (dateCreation as FormattedDate).tiempo
                  }`
                : ''}
            </span>
          )
        },
      },

      {
        Header: (props) => <KTableHeader tableProps={props} title='Nro orden lavado' />,
        accessor: 'nroOrdenLavado',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo de servicio' />,
        accessor: 'tipoServicio',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Responsable' />,
        accessor: 'responsable',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Empresa' />,
        accessor: 'empresa',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='DNI' />,
        accessor: 'dni',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fotocheck' />,
        accessor: 'fotocheck',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Nombres' />,
        accessor: 'nombres',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Apellidos' />,
        accessor: 'apellidos',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Centro de costos' />,
        accessor: 'centroCostos',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Precio por kilo' />,
        accessor: 'precioKilo',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Peso (Kg.)' />,
        accessor: 'pesoKg',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Total (S/.)' />,
        accessor: 'totalPrecio',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Cantidad de prendas' />,
        accessor: 'totalPrendas',
      },
    ],
    [data],
  )

  useEffect(() => {
    getLaundryList(search)
  }, [pagination.currentPage])
  useEffect(() => {
    getLaundryList(search)
  }, [search])

  return (
    <>
      {isAllowed('HISTORIALPESOS/LISTAR') && (
        <KTCard shadow className='m-5'>
          {loading ? <KTableLoading title='Cargando...' /> : null}
          <KTable data={data} columns={columns} />
        </KTCard>
      )}
    </>
  )
}

const TableLaundryHystoryWrapper: FC<PropsTable> = ({search}) => {
  return (
    <KTableProvider>
      <TableLaundryHystory search={search} />
    </KTableProvider>
  )
}

export {TableLaundryHystoryWrapper}
